export const polyfillIntersectionObserver = () => {
  // Intersection Observer polyfill for web, used by LazyItem
  require('intersection-observer');
};
